<template>
  <!-- <div class="qilianFooter">
    © 2015-2018 dscmall.cn 版权所有 ICP备案证书号:京ICP证150505号
    京ICP备14043829号-2 POWERED by 企链
  </div>-->
  <div class="qilianFooter">2018-2020 gongsibao.com 版权所有 ICP备案证书号:京ICP证150505号 京ICP备14043829号-2</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.qilianFooter {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #000007;
}
</style>
